import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
    palette: {
        
      primary: {
        main: '#808080',
      },
      secondary: {
        main: '#808080',
      },
    },
    overrides: {
        MuiToolbar: {
          root: {
            height: 'inherit !important',
            //minHeight: 10,
            maxHeight: 10,
          },
        },
        MuiButton: {
          root: {
            height: 'inherit !important',
            //minHeight: 10,
            minWidth: 0,
          },
        },
  }});;

  export default theme;